import { render } from "./VentasPlacaView.vue?vue&type=template&id=69f8c7c9&scoped=true"
import script from "./VentasPlacaView.vue?vue&type=script&lang=js"
export * from "./VentasPlacaView.vue?vue&type=script&lang=js"

import "./VentasPlacaView.vue?vue&type=style&index=0&id=69f8c7c9&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f8c7c9"]])

export default __exports__